export interface IFaqData {
  id: number
  question: string
  answer?: string
  list?: string[]
  multipleAnswer?: {
    answer: string
    list?: string[]
  }[]
}

export const faqData: IFaqData[] = [
  {
    id: 1,
    question: 'O que é a Sortezinha Inter?',
    multipleAnswer: [
      {
        answer:
          'É uma opção de título de capitalização, na modalidade popular, emitido pela Brasilcap. Você pode adquirir o seu título  pelo valor total de R$ 3,00, tem chances de ganhar prêmios e ainda resgatar 50% deste valor, atualizado pela TR (Taxa Referencial) ao final da vigência de 12 meses.',
      },
      {
        answer: 'A cada 500 mil títulos ao longo de 12 meses, você concorre a:',
        list: [
          '14.268 prêmios instantâneos de R$ 3,00, R$ 15,00, R$ 30,00, R$ 45,00, R$ 60,00 ou R$ 100,00.',
          '12 prêmios mensais de R$ 7.000,00.',
          '4 prêmios trimestrais de R$ 7.000,00',
        ],
      },
      {
        answer:
          'Caso você tenha adquirido seu título antes do dia 08/05/2024, consulte as Condições Gerais aplicáveis para informações sobre os sorteios.',
      },
    ],
  },
  {
    id: 2,
    question: 'Como comprar uma Sortezinha Inter?',
    answer:
      'Basta acessar a opção "Sortezinha" no menu "Outros produtos". Você também pode adquirir ao realizar uma recarga de celular no nosso Super App, ativando a compra do título durante esse processo.',
  },
  {
    id: 3,
    question: 'Como confiro as informações da Sortezinha que comprei?',
    answer:
      'Você pode visualizar todas as informações do seu título acessando a opção "Sortezinha", no menu "Outros produtos".',
  },
  {
    id: 4,
    question: 'Como saber se fui contemplado com o prêmio instantâneo e como recebo o valor?',
    answer:
      'Ao raspar seu título, você saberá na hora se foi contemplado: basta encontrar três valores iguais! Se isso acontecer, o valor do prêmio será depositado imediatamente na sua conta Inter. Você também pode acompanhar essa informação acessando “Sortezinha” no menu “Outros produtos”.',
  },
  {
    id: 5,
    question: 'Quantos números da sorte eu possuo?',
    answer:
      'Cada título possui um número da sorte, que concorrerá aos 16 (dezesseis) sorteios mensais e especiais.',
  },
  {
    id: 6,
    question: 'Como saber se ganhei em um sorteio?',
    answer:
      'Você concorre aos 16 sorteios com o seu número da sorte. Caso seja contemplado em algum sorteio, nós te avisaremos! Você também pode acompanhar tudo sobre os sorteios acessando a opção "Sortezinha", no menu "Outros produtos".',
  },
  {
    id: 7,
    question: 'Como são realizados os Sorteios Mensais e Trimestrais?',
    multipleAnswer: [
      {
        answer:
          'Os sorteios mensais e trimestrais são realizados ao longo de 12 meses de vigência, com base no resultado da Loteria Federal do Brasil (LFB).',
      },
      {
        answer:
          'O sorteio mensal ocorrerá sempre na primeira quarta-feira de cada mês civil. Seu primeiro sorteio mensal será sempre o da primeira quarta-feira do mês, a partir da data da compra.',
      },
      {
        answer:
          'Já para o sorteio trimestral as datas são definidas com base na data de compra do seu título. O primeiro sorteio trimestral ocorrerá na terceira quarta-feira do 3º mês a partir da data da sua compra. Após esse primeiro sorteio, você continuará concorrendo na terceira quarta-feira do 6º, 9º e 12º mês a partir da data da sua compra. Por exemplo: se você adquirir um  título no mês de agosto, irá participar dos sorteios trimestrais na terceira quarta-feira dos meses de outubro, janeiro, abril e julho.',
      },
      {
        answer:
          'Caso o sorteio do concurso da Loteria Federal do Brasil não seja realizado na data prevista, nem na imediata que a substitua, será considerada, para fins dos sorteios trimestrais, a primeira extração subsequente realizada pela Caixa Econômica Federal, desde que não coincidente com uma data já prevista para sorteio.',
      },
      {
        answer:
          'Caso seu número seja contemplado, nós te avisaremos! Para entender mais sobre como é feita a correspondência do número da sorte e o número sorteado pela loteria, acesse as Condições Gerais, no detalhe do seu título de capitalização, no menu “Sortezinha”.',
      },
    ],
  },
  {
    id: 8,
    question: 'Como faço para receber meu prêmio de R$7.000,00?',
    answer:
      'Caso você seja contemplado em um dos sorteios mensais e/ ou trimestrais, a gente te avisa! O valor de R$ 7.000,00  será depositado em sua conta corrente nos próximos 5 dias úteis subsequentes ao sorteio. Você também receberá um e-mail para compartilhar como foi sua experiência com a gente e poderá acompanhar todas as informações sobre os sorteios acessando a opção “Sortezinha”, no menu "Outros produtos".',
  },
  {
    id: 9,
    question: 'Quais são os meios de comunicação do Inter?',
    answer:
      'Caso você seja contemplado em um dos sorteios de R$ 7.000,00, tenha um título disponível, título próximo da data do fim da vigência, título encerrado ou o valor do seu resgate tenha sido efetuado, nós te avisaremos! Além disso, pode haver comunicações dentro do nosso Super App. Vale lembrar que nossa comunicação não é feita por WhatsApp ou SMS.',
  },
  {
    id: 10,
    question: 'O que são as Condições Gerais da Sortezinha Inter?',
    multipleAnswer: [
      {
        answer:
          'As Condições Gerais estabelecem as normas referentes ao título, incluindo os direitos e obrigações do subscritor/titular e da Sociedade de Capitalização (Brasilcap).',
      },
      {
        answer:
          'Nas Condições Gerais do seu título, você encontrará informações como o plano registrado na SUSEP, a vigência do título, os percentuais de contribuição destinados à capitalização, as regras do sorteio realizado pela Loteria Federal do Brasil, critério de atualização de valores e outras informações.',
      },
    ],
  },
  {
    id: 11,
    question: 'Como confiro as Condições Gerais?',
    multipleAnswer: [
      {
        answer: 'Para clientes que possuem um título:',
        list: [
          'Você pode acessar as Condições Gerais em "Sortezinha", localizado no menu "Outros produtos". Dentro dos detalhes do seu título, você encontrará os documentos, incluindo as Condições Gerais.',
        ],
      },
      {
        answer: 'Para clientes que ainda não possuem um título:',
        list: [
          'Você pode ler as Condições Gerais acessando o link fornecido antes de contratar o produto.',
        ],
      },
    ],
  },
  {
    id: 12,
    question: 'Qual o prazo de vigência do título e como faço para resgatar o valor do cashback?',
    answer:
      'A vigência da Sortezinha Inter é de 12 meses. Ao final desse período, você pode solicitar o seu  resgate (cashback) equivalente a 50% do valor pago, atualizado pela Taxa Referencial (TR), diretamente no nosso Super App. Se você não solicitar o resgate em até 15 dias após o término da vigência, o valor será depositado automaticamente na sua conta Inter.',
  },
  {
    id: 13,
    question: 'Existe alguma restrição de idade para participar da Sortezinha Inter?',
    answer: 'A venda está disponível apenas para maiores de 18 anos, completos na data da compra.',
  },
  {
    id: 14,
    question: 'Como posso entrar em contato com o suporte ao cliente?',
    multipleAnswer: [
      {
        answer: 'Você pode tirar suas dúvidas através do nosso chat no Super App.',
      },
      {
        answer: 'Além disso, é possível entrar em contato por:',
      },
      {
        answer: 'Central de Relacionamento:',
      },
      {
        answer: '3003 4070 (capitais e regiões metropolitanas)',
      },
      {
        answer: '0800 940 0007 (demais localidades)',
      },
      {
        answer: '0800 979 7099 (deficiente de fala e audição)',
      },
      {
        answer: 'SAC: 0800 940 9999',
      },
      {
        answer: 'Ouvidoria Banco Inter: 0800 940 7772',
      },
      {
        answer: 'Ouvidoria Brasilcap: 0800 729 3478',
      },
    ],
  },
  {
    id: 15,
    question: 'O valor dos prêmios será deduzido de imposto?',
    answer:
      'O valor informado já é o valor líquido que você receberá em caso de contemplação. O valor bruto de cada premiação (sem a dedução de eventuais impostos/taxas) está disponível nas  Condições Gerais do Produto.',
  },
  {
    id: 16,
    question: 'Como faço para cancelar um título?',
    answer:
      'Devido à sua natureza de premiação instantânea, a Sortezinha Inter não oferece a opção de cancelamento.',
  },
  {
    id: 17,
    question: 'Como vejo as informações da Sortezinha Inter que comprei ao realizar uma recarga?',
    answer:
      'Você pode visualizar todas as informações do seu título acessando a opção “Sortezinha”, no canto superior direito no menu da Recarga.',
  },
  {
    id: 18,
    question:
      'Ativei o Recarga Programada ao realizar uma recarga. O título também será programado?',
    answer:
      'Você pode comprar um título com a Recarga Programada ativada, mas receberá apenas um título. Ele estará disponível logo após a compra da primeira recarga.',
  },
]
